import NavigationButtons from "common/NavigationButtons/NavigationButtons";
import RadioButton from "common/Radio/RadioButton";
import { useContext } from "react";
import PersonalInformation from "../Common/PersonalInformation";

const ReviewInformation = ({ context }) => {
  const {
    labels,
    sanitize,
    payload,
    updatePayload,
    cancel,
    errors,
    setErrors,
    navigateToStep2,
  } = useContext(context);

  const confirmMaritalStatus = {
    name: "confirmMaritalStatus",
    data: [
      {
        label: labels?.incomeElection?.yes,
        id: "Y",
        ariaLabel: "Yes",
      },
      {
        label: labels?.incomeElection?.no,
        id: "N",
        ariaLabel: "No",
      },
    ],
  };

  return (
    <section className="section-one mb-3">
      <p className="fw-bold">{labels?.incomeElection?.reviewInfo}</p>
      <div
        className="border-bottom-1 pb-4"
        dangerouslySetInnerHTML={sanitize(
          labels?.incomeElection?.reviewInfoMsg
        )}
      />

      <PersonalInformation
        labels={labels}
        data={payload}
        updatePayload={updatePayload}
        errors={errors}
        setErrors={setErrors}
      />

      <div className="justify-content-center mx-auto border-1 p-4 w-80">
        <h5>{labels?.incomeElection?.maritalStatus}</h5>
        <p>{labels?.incomeElection?.maritalStatusMsg}</p>
        <RadioButton
          data={confirmMaritalStatus}
          value={payload?.maritalStatusConfirm}
          selected={(e) => updatePayload(e, "maritalStatusConfirm")}
        />
      </div>

      <NavigationButtons
        wrapperClassName="mt-5 pt-5 border-top-1"
        leftLabel={labels?.incomeElection?.cancel}
        leftClick={cancel}
        rightLabel={labels?.incomeElection?.next}
        rightClick={navigateToStep2}
        rightDisabled={errors?.email || errors?.mobile}
      />
    </section>
  );
};

export default ReviewInformation;
